<template>
  <div class="company-step2-form">
    <div v-if="formReady">
      <CompanyStep2WeflixPanel v-if="isWeflix" />

      <template v-else>
      <p v-if="isCorporate" class="step2-context">
        Weeduc Corporativo — configure site público, portal do colaborador e layout para entregar a loja pronta.
      </p>
      <p v-else class="step2-context">
        Weeduc Escolar — configure site, portal do aluno e layout.
      </p>

      <div class="step2-accordions">
      <!-- DOMÍNIO -->
      <section class="step2-accordion" :class="{ 'is-open': isSectionOpen('domain') }">
        <button
          type="button"
          class="step2-accordion__toggle"
          :aria-expanded="isSectionOpen('domain')"
          @click="toggleSection('domain')"
        >
          <span class="step2-accordion__copy">
            <strong>Domínio {{ isWeeduc ? 'Weeduc' : 'Weflix' }}</strong>
            <small>O sistema cria automaticamente um domínio com base no nome informado.</small>
          </span>
          <fa
            class="step2-accordion__chevron"
            :icon="isSectionOpen('domain') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
          />
        </button>
        <div v-show="isSectionOpen('domain')" class="step2-accordion__body">
        <div class="row">
          <div class="col-form-inner col-4 col-md-4 col-lg-4">
            <div class="form-group">
              <div class="form-label"><label>Nome do Domínio</label></div>
              <div class="form-input">
                <div class="domain-check">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Meu Domínio"
                    v-model="urlTemporary"
                    @keyup="createFullDomain()"
                  />
                  <span
                    v-if="hasValidDomain === true"
                    class="domain-check__status domain-check__status--ok"
                    title="Domínio disponível"
                    aria-label="Domínio disponível"
                  >
                    <fa icon="fa-solid fa-circle-check" />
                  </span>
                  <span
                    v-else-if="hasValidDomain === false"
                    class="domain-check__status domain-check__status--error"
                    title="Domínio indisponível"
                    aria-label="Domínio indisponível"
                  >
                    <fa icon="fa-solid fa-circle-xmark" />
                  </span>
                  <button type="button" class="btn_new" @click="validateDomain">Verificar</button>
                </div>
                <small>Apenas texto, sem espaços ou caracteres especiais. Máx. 30 caracteres.</small>
                <small v-if="hasValidDomain === true" class="ok domain-status-msg">
                  <fa icon="fa-solid fa-check" /> Domínio disponível.
                </small>
                <small v-else-if="hasValidDomain === false" class="error domain-status-msg">
                  <fa icon="fa-solid fa-xmark" /> Domínio indisponível.
                </small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-8 col-md-8 col-lg-8">
            <div class="form-group">
              <div class="form-label"><label>Domínio final</label></div>
              <div class="form-input">
                <div class="domain-check domain-check--final">
                  <input type="text" class="form-control" v-model="url" disabled />
                  <button type="button" class="btn_new" @click="copyLink" :disabled="!url">Copiar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>Domínio primário</label></div>
              <div class="form-input">
                <input type="text" class="form-control" v-model="url1" placeholder="https://www.seudominio.com.br" />
                <small>URL alternativa de acesso ao site.</small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>Domínio adicional</label></div>
              <div class="form-input">
                <input type="text" class="form-control" v-model="url2" placeholder="https://app.seudominio.com.br" />
                <small>Segundo endereço para o mesmo site.</small>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      <!-- BÁSICO / SITE -->
      <section class="step2-accordion" :class="{ 'is-open': isSectionOpen('basic') }">
        <button
          type="button"
          class="step2-accordion__toggle"
          :aria-expanded="isSectionOpen('basic')"
          @click="toggleSection('basic')"
        >
          <span class="step2-accordion__copy">
            <strong>{{ isCorporate ? 'Site público' : 'SEO e identidade' }}</strong>
            <small>Informações usadas por buscadores e identidade visual do site</small>
          </span>
          <fa
            class="step2-accordion__chevron"
            :icon="isSectionOpen('basic') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
          />
        </button>
        <div v-show="isSectionOpen('basic')" class="step2-accordion__body">

        <div class="row" v-if="isCorporate || isWeeduc">
          <div class="col-form-inner col-12">
            <div class="step2-toggle-list">
              <div class="step2-toggle-row">
                <div class="step2-toggle-row__copy">
                  <strong>Site público ativo</strong>
                  <p>Quando desativado, o site público redireciona para o login/portal.</p>
                </div>
                <label class="step2-switch">
                  <input type="checkbox" v-model="siteEnabled" />
                  <span class="step2-switch__track" aria-hidden="true"></span>
                  <span class="step2-switch__text">{{ siteEnabled ? 'Ativo' : 'Inativo' }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <template v-if="siteEnabled">
        <div class="row">
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>Título</label></div>
              <div class="form-input">
                <input type="text" required class="form-control" v-model="title" placeholder="Título do site" />
                <small>Título do site utilizado para mecanismos de pesquisa (SEO).</small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>E-mail do site</label></div>
              <div class="form-input">
                <input type="text" required class="form-control" v-model="emailSite" placeholder="exemplo@dominio.com" />
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>WhatsApp / Telefone</label></div>
              <div class="form-input">
                <input
                  type="text"
                  required
                  class="form-control"
                  v-model="phoneSite"
                  placeholder="Digite o telefone"
                  v-mask="'(##) #####-####'"
                />
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>Cor da Empresa</label></div>
              <div class="form-input">
                <div class="inputsColors">
                  <input type="color" :value="colorValue" @input="color = $event.target.value" />
                  <input
                    type="text"
                    required
                    class="form-control"
                    v-model="color"
                    placeholder="#ffffff"
                    @blur="color = normalizeHex(color)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-12">
            <div class="form-group">
              <div class="form-label"><label>Sugestões de Cores</label></div>
              <div class="wrap-suggested-colors">
                <span
                  v-for="hex in suggestedColors"
                  :key="hex"
                  :style="{ backgroundColor: hex }"
                  @click="setColor(hex)"
                ></span>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-12 step2-field-spaced">
            <div class="form-group">
              <div class="form-label"><label>Descrição</label></div>
              <div class="form-input">
                <textarea class="form-control textarea_input" v-model="description"></textarea>
                <small>Descrição do site utilizada para mecanismos de pesquisa (SEO).</small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-12">
            <div class="form-group">
              <div class="form-label"><label>Sobre</label></div>
              <div class="form-input">
                <textarea class="form-control textarea_input" v-model="about"></textarea>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-12">
            <div class="form-group">
              <div class="form-label"><label>Palavras-chave</label></div>
              <div class="form-input">
                <textarea class="form-control textarea_input" v-model="keywords"></textarea>
                <small>Separe as palavras-chave por vírgula.</small>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <h4>{{ isCorporate ? 'Layout do portal — Logo' : 'Identidade visual' }}</h4>
          <p>Logo e favicon exibidos no site{{ isCorporate ? ' e no portal do colaborador' : '' }}</p>
        </div>
        <div class="row">
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label">
                <label>Logo</label>
                <small>Altura máxima recomendada: 80px. PNG, JPG ou WEBP.</small>
              </div>
              <div class="form-file">
                <div class="file-wrapper primary">
                  <img v-show="logoDisplay" :src="logoDisplay" alt="Logo" class="file-preview" />
                  <span class="thumbnail" v-show="!logoDisplay">
                    <fa icon="fa-solid fa-image" />
                    <span class="text">Clique para selecionar a imagem</span>
                  </span>
                  <LoaderImage :hasReady="loaderImage" />
                  <input class="form-control" type="file" @change="updateFilePathLogo" accept=".png, .jpg, .jpeg, .webp" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label">
                <label>Favicon</label>
                <small>PNG, JPG, WEBP ou ICO.</small>
              </div>
              <div class="form-file">
                <div class="file-wrapper primary">
                  <img v-show="faviconDisplay" :src="faviconDisplay" alt="Favicon" class="file-preview" />
                  <span class="thumbnail" v-show="!faviconDisplay">
                    <fa icon="fa-solid fa-image" />
                    <span class="text">Clique para selecionar a imagem</span>
                  </span>
                  <LoaderImage :hasReady="loaderImage" />
                  <input class="form-control" type="file" @change="updateFilePathFavicon" accept=".png, .jpg, .jpeg, .webp, .ico" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <h4>Imagem do portal</h4>
          <p>Banner do portal. Tamanho recomendado: 1280×500 (16:5).</p>
        </div>
        <div class="row">
          <div class="col-form-inner col-12">
            <div class="form-group">
              <div class="form-file">
                <div class="file-wrapper primary file-wrapper--banner">
                  <img v-show="portalBannerDisplay" :src="portalBannerDisplay" alt="Banner portal" class="file-preview" />
                  <span class="thumbnail" v-show="!portalBannerDisplay">
                    <fa icon="fa-solid fa-image" />
                    <span class="text">Selecione uma imagem no formato JPG ou PNG</span>
                  </span>
                  <LoaderImage :hasReady="loaderImage" />
                  <input class="form-control" type="file" @change="updateFilePathPortalBanner" accept=".png, .jpg, .jpeg, .webp" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <h4>Integrações</h4>
          <p>Pixels, medição e RD Station.</p>
        </div>
        <div class="row">
          <div class="col-form-inner col-6 col-md-6" v-for="field in integrationFields" :key="field.key">
            <div class="form-group">
              <div class="form-label"><label>{{ field.label }}</label></div>
              <div class="form-input">
                <input type="text" class="form-control" v-model="integrations[field.key]" :placeholder="field.placeholder" />
                <small>{{ field.hint }}</small>
              </div>
            </div>
          </div>
        </div>
        <div class="section-title">
          <h4>RD Station</h4>
          <p>Integração com automação e CRM (quando aplicável ao plano).</p>
        </div>
        <div class="row">
          <div class="col-form-inner col-6 col-md-6" v-for="field in rdFields" :key="'rd-' + field.key">
            <div class="form-group">
              <div class="form-label"><label>{{ field.label }}</label></div>
              <div class="form-input">
                <input type="text" class="form-control" v-model="integrations[field.key]" :placeholder="field.placeholder" />
                <small>{{ field.hint }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <h4>Avançado</h4>
          <p>CSS e JavaScript customizados. Use com cuidado.</p>
        </div>
        <div class="row">
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>CSS (loja virtual)</label></div>
              <div class="form-input">
                <textarea class="form-control textarea_input step2-code" v-model="css" placeholder="<style>...</style>"></textarea>
                <small class="warn">CSS customizado pode afetar o funcionamento do site.</small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6">
            <div class="form-group">
              <div class="form-label"><label>JS (portal)</label></div>
              <div class="form-input">
                <textarea class="form-control textarea_input step2-code" v-model="javascript" placeholder="<script>...</script>"></textarea>
                <small class="warn">JS customizado pode afetar o funcionamento do portal.</small>
              </div>
            </div>
          </div>
        </div>
        </template>
        </div>
      </section>

      <!-- PORTAL (colaborador ou aluno) -->
      <section
        v-if="isWeeduc"
        class="step2-accordion"
        :class="{ 'is-open': isSectionOpen('portal') }"
      >
        <button
          type="button"
          class="step2-accordion__toggle"
          :aria-expanded="isSectionOpen('portal')"
          @click="toggleSection('portal')"
        >
          <span class="step2-accordion__copy">
            <strong>{{ isCorporate ? 'Portal do colaborador' : 'Portal do aluno' }}</strong>
            <small>Módulos exibidos no portal (certificado, dúvidas e fórum).</small>
          </span>
          <fa
            class="step2-accordion__chevron"
            :icon="isSectionOpen('portal') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
          />
        </button>
        <div v-show="isSectionOpen('portal')" class="step2-accordion__body">
        <div class="step2-toggle-list">
          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Exibir certificado</strong>
              <p>Exibe a área de certificados no portal do {{ portalAudienceLabel }}.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="showCertificate" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ showCertificate ? 'Sim' : 'Não' }}</span>
            </label>
          </div>
          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Exibir dúvidas</strong>
              <p>Exibe a área de dúvidas no portal do {{ portalAudienceLabel }}.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="showInquiry" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ showInquiry ? 'Sim' : 'Não' }}</span>
            </label>
          </div>
          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Exibir fórum</strong>
              <p>Exibe o fórum no portal do {{ portalAudienceLabel }}.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="showForum" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ showForum ? 'Sim' : 'Não' }}</span>
            </label>
          </div>
        </div>
        </div>
      </section>

      <!-- LAYOUT / TEMAS -->
      <section class="step2-accordion" :class="{ 'is-open': isSectionOpen('layout') }">
        <button
          type="button"
          class="step2-accordion__toggle"
          :aria-expanded="isSectionOpen('layout')"
          @click="toggleSection('layout')"
        >
          <span class="step2-accordion__copy">
            <strong>Temas e layout</strong>
            <small>{{ !siteEnabled ? (isCorporate ? 'Tema do portal do colaborador.' : 'Tema do portal do aluno.') : ('Tema da loja virtual' + (isWeeduc ? ' e do portal' : '') + '.') }}</small>
          </span>
          <fa
            class="step2-accordion__chevron"
            :icon="isSectionOpen('layout') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
          />
        </button>
        <div v-show="isSectionOpen('layout')" class="step2-accordion__body">
        <div class="row">
          <div class="col-form-inner col-6 col-md-6" v-if="siteEnabled">
            <div class="form-group">
              <div class="form-label">
                <label>{{ isWeflix ? 'Tema do site (Netflix / Light)' : 'Tema loja virtual' }}</label>
              </div>
              <div class="form-input">
                <select class="form-control" v-model="typeLayout">
                  <option value="" disabled>Selecione o tipo</option>
                  <option :value="0">{{ isWeflix ? 'Netflix (escuro)' : 'Dark' }}</option>
                  <option :value="1">{{ isWeflix ? 'Light' : 'Light / Clean' }}</option>
                </select>
                <small>{{ isWeflix ? 'Netflix: visual escuro. Light: design claro e minimalista.' : 'Clean: cores claras. Dark: fundo escuro e alto contraste.' }}</small>
              </div>
            </div>
          </div>
          <div class="col-form-inner col-6 col-md-6" v-if="isWeeduc">
            <div class="form-group">
              <div class="form-label">
                <label>{{ isCorporate ? 'Tema portal do colaborador' : 'Tema portal do aluno' }}</label>
              </div>
              <div class="form-input">
                <select class="form-control" v-model="typeLayoutPortal">
                  <option value="" disabled>Selecione o tipo</option>
                  <option :value="1">Clean</option>
                  <option :value="2">Dark</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <template v-if="isWeflix">
          <div class="section-title">
            <h4>Exibição de catálogo</h4>
            <p>Formato de capa e títulos dos vídeos no Weflix.</p>
          </div>
          <div class="row">
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Formato da capa do curso</label></div>
                <div class="form-input">
                  <select class="form-control" v-model="typeImageCoverCourse">
                    <option :value="1">Capa Horizontal (1920 × 200px)</option>
                    <option :value="2">Capa Vertical (240 × 440px)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-form-inner col-6 col-md-6">
              <div class="form-group">
                <div class="form-label"><label>Exibir títulos dos vídeos</label></div>
                <div class="form-input">
                  <select class="form-control" v-model="visibleTitleCourse">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="section-title">
            <h4>Checkout e carrinho</h4>
            <p>Configurações gerais da loja Weflix.</p>
          </div>
          <div class="step2-toggle-list">
            <div class="step2-toggle-row">
              <div class="step2-toggle-row__copy">
                <strong>Fechamento de carrinho</strong>
                <p>Quando ativo, o fluxo de compra exige fechamento do carrinho.</p>
              </div>
              <label class="step2-switch">
                <input type="checkbox" v-model="cartClosure" />
                <span class="step2-switch__track" aria-hidden="true"></span>
                <span class="step2-switch__text">{{ cartClosure ? 'Ativo' : 'Inativo' }}</span>
              </label>
            </div>
            <div class="step2-toggle-row">
              <div class="step2-toggle-row__copy">
                <strong>Exibir valor parcelado no checkout</strong>
                <p>Mostra estimativa de parcelas na tela de pagamento.</p>
              </div>
              <label class="step2-switch">
                <input type="checkbox" v-model="showInstallmentValue" />
                <span class="step2-switch__track" aria-hidden="true"></span>
                <span class="step2-switch__text">{{ showInstallmentValue ? 'Ativo' : 'Inativo' }}</span>
              </label>
            </div>
          </div>
        </template>
        </div>
      </section>

      <!-- CONTEÚDO DO SITE -->
      <section v-if="siteEnabled" class="step2-accordion" :class="{ 'is-open': isSectionOpen('content') }">
        <button
          type="button"
          class="step2-accordion__toggle"
          :aria-expanded="isSectionOpen('content')"
          @click="toggleSection('content')"
        >
          <span class="step2-accordion__copy">
            <strong>Seções da página inicial</strong>
            <small>Ative e configure os blocos do site público.</small>
          </span>
          <fa
            class="step2-accordion__chevron"
            :icon="isSectionOpen('content') ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
          />
        </button>
        <div v-show="isSectionOpen('content')" class="step2-accordion__body">

        <div class="step2-toggle-list step2-content-blocks">
          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Banner principal</strong>
              <p>Imagem e texto de destaque no topo do site.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="banner1Active" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ banner1Active ? 'Ativo' : 'Inativo' }}</span>
            </label>
          </div>
          <div v-if="banner1Active" class="step2-block-fields">
            <div class="row">
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-file">
                    <div class="file-wrapper primary file-wrapper--banner">
                      <img v-show="bannerDisplay" :src="bannerDisplay" alt="Banner" class="file-preview" />
                      <span class="thumbnail" v-show="!bannerDisplay">
                        <fa icon="fa-solid fa-image" />
                        <span class="text">Clique para selecionar a imagem</span>
                      </span>
                      <LoaderImage :hasReady="loaderImage" />
                      <input class="form-control" type="file" @change="updateFilePathBanner" accept=".png, .jpg, .jpeg, .webp" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6">
                <div class="form-group">
                  <div class="form-label"><label>Título</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="bannerTitle" placeholder="Título" />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6">
                <div class="form-group">
                  <div class="form-label"><label>URL</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="bannerUrl" placeholder="https://seucurso.com.br" />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-label"><label>Descrição</label></div>
                  <div class="form-input">
                    <textarea class="form-control textarea_input" v-model="bannerDescription" placeholder="Texto de apoio do banner"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Seção de cursos</strong>
              <p>Lista de cursos/coleções na página inicial.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="coursesActive" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ coursesActive ? 'Ativo' : 'Inativo' }}</span>
            </label>
          </div>
          <div v-if="coursesActive" class="step2-block-fields">
            <div class="row">
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-label"><label>Título da seção</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="coursesTitle" placeholder="Nossos cursos" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Banner institucional</strong>
              <p>Segundo banner de conteúdo / chamada institucional.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="banner2Active" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ banner2Active ? 'Ativo' : 'Inativo' }}</span>
            </label>
          </div>
          <div v-if="banner2Active" class="step2-block-fields">
            <div class="row">
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-file">
                    <div class="file-wrapper primary file-wrapper--banner">
                      <img v-show="banner2Display" :src="banner2Display" alt="Banner 2" class="file-preview" />
                      <span class="thumbnail" v-show="!banner2Display">
                        <fa icon="fa-solid fa-image" />
                        <span class="text">Clique para selecionar a imagem</span>
                      </span>
                      <LoaderImage :hasReady="loaderImage" />
                      <input class="form-control" type="file" @change="updateFilePathBanner2" accept=".png, .jpg, .jpeg, .webp" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6">
                <div class="form-group">
                  <div class="form-label"><label>Título</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="banner2Title" placeholder="Título" />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-6 col-md-6">
                <div class="form-group">
                  <div class="form-label"><label>URL</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="banner2Url" placeholder="https://..." />
                  </div>
                </div>
              </div>
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-label"><label>Descrição</label></div>
                  <div class="form-input">
                    <textarea class="form-control textarea_input" v-model="banner2Description" placeholder="Texto institucional"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Depoimentos</strong>
              <p>Seção com até 2 depoimentos na página inicial.</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="testimonialsActive" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ testimonialsActive ? 'Ativo' : 'Inativo' }}</span>
            </label>
          </div>
          <div v-if="testimonialsActive" class="step2-block-fields">
            <div class="row">
              <div class="col-form-inner col-12">
                <div class="form-group">
                  <div class="form-label"><label>Título da seção</label></div>
                  <div class="form-input">
                    <input type="text" class="form-control" v-model="testimonialsTitle" placeholder="O que dizem nossos alunos" />
                  </div>
                </div>
              </div>
              <div
                v-for="(item, index) in testimonials"
                :key="`testimony-${index}`"
                class="col-form-inner col-6 col-md-6"
              >
                <div class="step2-testimonial-card">
                  <div class="form-group">
                    <div class="form-label"><label>Depoimento {{ index + 1 }} — foto</label></div>
                    <div class="form-file">
                      <div class="file-wrapper primary">
                        <img
                          v-show="item.preview || item.photoFinal || item.photo"
                          :src="item.preview || item.photoFinal || item.photo"
                          alt="Foto"
                          class="file-preview"
                        />
                        <span class="thumbnail" v-show="!(item.preview || item.photoFinal || item.photo)">
                          <fa icon="fa-solid fa-user" />
                          <span class="text">Foto</span>
                        </span>
                        <input
                          class="form-control"
                          type="file"
                          accept=".png, .jpg, .jpeg, .webp"
                          @change="updateFilePathTestimony($event, index)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label"><label>Nome</label></div>
                    <div class="form-input">
                      <input type="text" class="form-control" v-model="item.name" placeholder="Nome" />
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label"><label>Depoimento</label></div>
                    <div class="form-input">
                      <textarea class="form-control textarea_input" v-model="item.description" placeholder="Texto do depoimento"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="step2-toggle-row">
            <div class="step2-toggle-row__copy">
              <strong>Redes sociais</strong>
              <p>Links exibidos no site (Facebook, Instagram, etc.).</p>
            </div>
            <label class="step2-switch">
              <input type="checkbox" v-model="socialActive" />
              <span class="step2-switch__track" aria-hidden="true"></span>
              <span class="step2-switch__text">{{ socialActive ? 'Ativo' : 'Inativo' }}</span>
            </label>
          </div>
          <div v-if="socialActive" class="step2-block-fields">
            <div class="row">
              <div
                v-for="(name, index) in socialNames"
                :key="`social-${index}`"
                class="col-form-inner col-6 col-md-6"
              >
                <div class="step2-social-row">
                  <div class="step2-social-row__head">
                    <strong>{{ name }}</strong>
                    <label class="step2-switch">
                      <input type="checkbox" v-model="socialEnabled[index]" />
                      <span class="step2-switch__track" aria-hidden="true"></span>
                      <span class="step2-switch__text">{{ socialEnabled[index] ? 'On' : 'Off' }}</span>
                    </label>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="socialLinks[index]"
                    :placeholder="socialPlaceholders[index]"
                    :disabled="!socialEnabled[index]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      </div>
      </template>

      <div class="step2-footer">
        <button
          v-if="showCancel"
          type="button"
          class="btnSave btnCancel"
          @click="$emit('cancel')"
          :disabled="!hasReady || fillingPreview"
        >
          Voltar
        </button>

        <button
          v-if="showFillPreview"
          type="button"
          class="btnSave btnFillPreview"
          @click="fillPreviewData"
          :disabled="!hasReady || fillingPreview"
        >
          <span v-if="!fillingPreview">Preencher dados</span>
          <span v-else>Gerando dados...</span>
        </button>

        <div class="step2-footer__spacer"></div>

        <button
          type="button"
          class="btnSave"
          @click="saveLayout"
          :disabled="!hasReady || fillingPreview"
        >
          <span v-if="hasReady">{{ finalizeLabel }}</span>
          <span v-else>Salvando...</span>
        </button>
      </div>
    </div>
    <Loader v-if="showLoader" :hasReady="formReady && hasReady" />

    <v-dialog v-model="showDomainRequiredModal" max-width="420">
      <v-card class="domain-required-modal">
        <v-card-title class="domain-required-modal__title">Informe o domínio</v-card-title>
        <v-card-text class="domain-required-modal__text">
          Insira o nome do domínio antes de validar.
        </v-card-text>
        <v-card-actions class="domain-required-modal__actions">
          <button type="button" class="domain-required-modal__btn" @click="showDomainRequiredModal = false">
            Entendi
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';
import apiAWS from '@/utils/storage/aws';
import apiSiteDomain from '@/utils/Site/domain';
import superAdmin from '@/utils/superAdmin';
import Loader from '@/components/Weflix/Loader.vue';
import LoaderImage from '@/components/Weflix/LoaderImage.vue';
import CompanyStep2WeflixPanel from '@/components/Weflix/SuperAdmin/CompanyStep2WeflixPanel.vue';

function extractWebsite(source) {
  if (!source || typeof source !== 'object') return null;
  if (source.website) return source.website;
  if (Array.isArray(source.listWebsite) && source.listWebsite[0]) return source.listWebsite[0];
  if (Array.isArray(source.websites) && source.websites[0]) return source.websites[0];
  if (source.url || source.title || source.logo || source.logoFinal) return source;
  return null;
}

function subdomainFromUrl(url, suffix) {
  if (!url) return '';
  try {
    const host = new URL(url).hostname || '';
    const ends = `.${suffix}.com.br`;
    if (host.endsWith(ends)) return host.slice(0, -ends.length);
    return host.split('.')[0] || '';
  } catch {
    return '';
  }
}

function toFlag(value, fallback = true) {
  if (value === undefined || value === null || value === '') return fallback;
  return value === true || value === 1 || value === '1';
}

function flagNumber(value) {
  return value ? 1 : 0;
}

export default {
  name: 'CompanyStep2Form',
  components: { Loader, LoaderImage, CompanyStep2WeflixPanel },
  provide() {
    return {
      step2Form: this,
    };
  },
  props: {
    companyId: { type: [Number, String], required: true },
    typeSystem: { type: [Number, String], default: 1 },
    typeBusiness: { type: [Number, String], default: null },
    representativeId: { type: [Number, String], default: null },
    initialWebsite: { type: Object, default: null },
    initialCompany: { type: Object, default: null },
    companyColor: { type: String, default: '#ffffff' },
    redirectOnSave: { type: Boolean, default: false },
    notifyOnSave: { type: Boolean, default: true },
    showCancel: { type: Boolean, default: false },
    showLoader: { type: Boolean, default: true },
    showFillPreview: { type: Boolean, default: false },
    finalizeLabel: { type: String, default: 'Finalizar' },
    syncStepQuery: { type: Boolean, default: true },
  },
  emits: ['saved', 'cancel', 'ready', 'step-change'],
  data() {
    return {
      openSections: {
        basic: true,
        domain: true,
        domains: true,
        portal: true,
        themes: true,
        layout: true,
        social: true,
        content: true,
        integrations: true,
        advanced: true,
        general: true,
      },
      logo: null,
      favicon: null,
      logoPreview: null,
      faviconPreview: null,
      logoFinal: null,
      faviconFinal: null,
      title: null,
      description: null,
      keywords: null,
      urlTemporary: null,
      about: null,
      url: null,
      url1: null,
      url2: null,
      typeLayout: null,
      typeLayoutPortal: null,
      emailSite: null,
      phoneSite: null,
      primaryBanner: null,
      primaryBannerPreview: null,
      primaryBannerFinal: null,
      bannerTitle: '',
      bannerUrl: '',
      bannerDescription: '',
      banner1Active: true,
      banner2Active: false,
      banner2: null,
      banner2Preview: null,
      banner2Final: null,
      banner2Title: '',
      banner2Url: '',
      banner2Description: '',
      coursesActive: true,
      coursesTitle: 'Nossos cursos',
      testimonialsActive: false,
      testimonialsTitle: 'Depoimentos',
      testimonials: [
        { id: null, name: '', description: '', photo: '', photoFinal: '', preview: null },
        { id: null, name: '', description: '', photo: '', photoFinal: '', preview: null },
      ],
      socialActive: false,
      socialNames: ['Facebook', 'Instagram', 'Youtube', 'Linkedin', 'Whatsapp', 'TikTok'],
      socialPlaceholders: [
        'facebook.com/suapagina',
        'instagram.com/suapagina',
        'youtube.com/canal',
        'linkedin.com/empresa',
        'whatsapp.com/numero',
        'tiktok.com/@usuario',
      ],
      socialEnabled: [false, false, false, false, false, false],
      socialLinks: ['', '', '', '', '', ''],
      socialIds: [null, null, null, null, null, null],
      contentIds: { 1: null, 2: null, 3: null, 4: null },
      typeImageCoverCourse: 1,
      visibleTitleCourse: true,
      cartClosure: false,
      showInstallmentValue: false,
      companyName: '',
      portalBanner: null,
      portalBannerPreview: null,
      portalBannerFinal: null,
      siteEnabled: true,
      showCertificate: true,
      showInquiry: true,
      showForum: true,
      integrations: {
        facebookPixelCode: '',
        googleAdsCode: '',
        googleAnalyticsCode: '',
        tagManagerCode: '',
        rdrefreshToken: '',
        rdcode: '',
        rdsecretClient: '',
        rdclienteId: '',
      },
      css: '',
      javascript: '',
      color: '#ffffff',
      hasValidDomain: null,
      showDomainRequiredModal: false,
      hasReady: true,
      formReady: false,
      loaderImage: true,
      fillingPreview: false,
      suggestedColors: [
        '#1AB490', '#28C565', '#2E8DD6', '#904EAC', '#B93126',
        '#E54236', '#E47220', '#EFBC11', '#250891', '#FF69B4',
        '#4B0082', '#006400', '#8B4513', '#00008B',
      ],
      integrationFields: [
        { key: 'facebookPixelCode', label: 'Facebook Pixel', placeholder: 'Ex.: ID do pixel', hint: 'Código para rastrear visitantes.' },
        { key: 'googleAdsCode', label: 'Google Ads Pixel', placeholder: 'Ex.: AW-XXXXXXXXX', hint: 'Código para monitorar conversões.' },
        { key: 'googleAnalyticsCode', label: 'Google Analytics', placeholder: 'Ex.: G-XXXXXXXXXX', hint: 'Código para acompanhar acessos.' },
        { key: 'tagManagerCode', label: 'Google Tag Manager', placeholder: 'Ex.: GTM-XXXXXXX', hint: 'Container do Tag Manager.' },
      ],
      rdFields: [
        { key: 'rdrefreshToken', label: 'RDRefresh', placeholder: 'Token RDRefresh', hint: 'Token para automação.' },
        { key: 'rdcode', label: 'RD Station — código', placeholder: 'Código da integração', hint: 'Código RD Station.' },
        { key: 'rdsecretClient', label: 'RD Station — secret', placeholder: 'Client secret', hint: 'Chave secreta.' },
        { key: 'rdclienteId', label: 'RD Station — client ID', placeholder: 'Client ID', hint: 'Identificador do cliente.' },
      ],
    };
  },
  computed: {
    ...mapState(['token', 'currentCompanyCreated']),
    isWeeduc() {
      return String(this.typeSystem) === '1';
    },
    isWeflix() {
      return String(this.typeSystem) === '2';
    },
    isCorporate() {
      return this.isWeeduc && String(this.typeBusiness) === '2';
    },
    domainSuffix() {
      return this.isWeeduc ? 'weeduc' : 'weflix';
    },
    colorValue() {
      return this.normalizeHex(this.color);
    },
    resolvedCompanyId() {
      return this.companyId
        || this.currentCompanyCreated?.company?.id
        || this.$route?.params?.slug;
    },
    resolvedRepresentativeId() {
      return this.representativeId
        || this.currentCompanyCreated?.representative?.id
        || this.resolvedCompanyId;
    },
    logoDisplay() {
      return this.logoPreview || this.logoFinal || this.logo;
    },
    faviconDisplay() {
      return this.faviconPreview || this.faviconFinal || this.favicon;
    },
    bannerDisplay() {
      return this.primaryBannerPreview || this.primaryBannerFinal || this.primaryBanner;
    },
    banner2Display() {
      return this.banner2Preview || this.banner2Final || this.banner2;
    },
    portalBannerDisplay() {
      return this.portalBannerPreview || this.portalBannerFinal || this.portalBanner;
    },
    visibleSteps() {
      if (this.isWeflix) {
        return [
          { id: 'domains', label: 'Domínios' },
          { id: 'basic', label: 'Básico' },
          { id: 'themes', label: 'Temas' },
          { id: 'social', label: 'Redes sociais' },
          { id: 'general', label: 'Geral' },
        ];
      }
      const steps = [
        { id: 'domain', label: 'Domínio' },
        { id: 'basic', label: this.isCorporate ? 'Site' : 'Básico' },
      ];
      if (this.isWeeduc) {
        steps.push({
          id: 'portal',
          label: this.isCorporate ? 'Portal' : 'Portal do aluno',
        });
      }
      steps.push({ id: 'layout', label: 'Layout' });
      if (this.siteEnabled) {
        steps.push({ id: 'content', label: 'Conteúdo' });
      }
      return steps;
    },
    portalAudienceLabel() {
      return this.isCorporate ? 'colaborador' : 'aluno';
    },
  },
  watch: {
    initialWebsite: {
      deep: true,
      handler(value) {
        if (value) this.applyWebsite(value);
      },
    },
    companyId() {
      this.bootstrap();
    },
  },
  methods: {
    isSectionOpen(sectionId) {
      return !!this.openSections?.[sectionId];
    },
    setWeflixTab(tabId) {
      if (tabId === 'social') this.socialActive = true;
      this.openSection(tabId);
    },
    toggleSection(sectionId) {
      this.openSections = {
        ...this.openSections,
        [sectionId]: !this.openSections[sectionId],
      };
      this.emitStepChange();
    },
    openSection(sectionId) {
      if (!sectionId) return;
      this.openSections = {
        ...this.openSections,
        [sectionId]: true,
      };
    },
    emitStepChange() {
      const openIds = this.visibleSteps
        .map((step) => step.id)
        .filter((id) => this.isSectionOpen(id));
      this.$emit('step-change', {
        openIds,
        label: openIds.length ? `${openIds.length} seções abertas` : 'Formulário completo',
        progressLabel: '',
        total: this.visibleSteps.length,
      });
    },
    syncStepToQuery() {
      if (!this.syncStepQuery || !this.$router) return;
      const query = { ...this.$route.query };
      delete query.siteStep;
      this.$router.replace({ query }).catch(() => {});
    },
    applyStepFromQuery() {
      const stepId = this.$route?.query?.siteStep || this.$route?.query?.step;
      if (!stepId || typeof stepId !== 'string') return;
      // Ignore CompanySuperAdmin tab markers (step=1|2|3 or tab=layout)
      if (stepId === '1' || stepId === '2' || stepId === '3' || stepId === 'layout') return;
      if (this.isWeflix && this.visibleSteps.some((step) => step.id === stepId)) {
        this.setWeflixTab(stepId);
        return;
      }
      if (this.visibleSteps.some((step) => step.id === stepId)) {
        this.openSection(stepId);
      }
    },
    async fillPreviewData(section) {
      if (this.fillingPreview) return;
      const only = typeof section === 'string' ? section : null;
      const want = (id) => !only || only === id;
      this.fillingPreview = true;
      this.hasReady = false;
      try {
        const isBlank = (value) => value == null || String(value).trim() === '';
        const hasAsset = (...values) => values.some((value) => !isBlank(value));
        const fillText = (key, value) => {
          if (isBlank(this[key])) this[key] = value;
        };

        const stamp = Date.now();
        const companyPart = String(this.resolvedCompanyId || 'demo').replace(/\D/g, '') || 'demo';
        const slug = `empresa${companyPart}`.slice(0, 24).toLowerCase();
        const brandColor = '#250891';
        const defaultTitle = this.isWeflix
          ? 'Weflix Preview'
          : (this.isCorporate ? 'Weeduc Corporativo Preview' : 'Meu Site Preview');

        if (want('basic')) {
          fillText('title', defaultTitle);
          fillText('emailSite', `contato+${stamp}@avengers.com`);
          fillText('phoneSite', '21994647568');
          fillText('description', 'Plataforma de educação e treinamentos online para escolas e empresas.');
          fillText('about', 'Somos uma empresa de tecnologia focada em educação digital.');
          fillText('keywords', 'educacao, cursos, treinamento, ead, weeduc');
        }

        if (want('color')) {
          this.color = brandColor;
        }

        if (want('integrations')) {
          const integrationDefaults = {
            facebookPixelCode: '123456789012345',
            googleAdsCode: 'AW-123456789',
            googleAnalyticsCode: 'G-PREVIEW01',
            tagManagerCode: 'GTM-PREVIEW',
            rdrefreshToken: 'rd-refresh-preview',
            rdcode: 'rd-code-preview',
            rdsecretClient: 'rd-secret-preview',
            rdclienteId: 'rd-client-preview',
          };
          const currentIntegrations = { ...(this.integrations || {}) };
          Object.entries(integrationDefaults).forEach(([key, value]) => {
            if (isBlank(currentIntegrations[key])) currentIntegrations[key] = value;
          });
          this.integrations = currentIntegrations;
        }

        if (want('advanced')) {
          fillText('css', '<style>\n.preview-slot { color: inherit; }\n</style>');
          fillText('javascript', `<${'script'}>\nconsole.log("preview");\n</${'script'}>`);
        }

        if (want('themes')) {
          if (this.typeLayout == null || this.typeLayout === '') this.typeLayout = 1;
          if (this.isWeeduc && (this.typeLayoutPortal == null || this.typeLayoutPortal === '')) {
            this.typeLayoutPortal = 1;
          }
          if (this.typeImageCoverCourse == null || this.typeImageCoverCourse === '') {
            this.typeImageCoverCourse = 1;
          }
          if (this.visibleTitleCourse == null) this.visibleTitleCourse = true;
        }

        if (want('general')) {
          this.cartClosure = true;
          this.showInstallmentValue = true;
        }

        if (want('domains')) {
          if (isBlank(this.urlTemporary) && isBlank(this.url)) {
            this.urlTemporary = slug;
            this.createFullDomain();
          } else if (!isBlank(this.urlTemporary) && isBlank(this.url)) {
            this.createFullDomain();
          }
          fillText('url1', `https://www.${slug}.com.br`);
          fillText('url2', `https://app.${slug}.com.br`);
        }

        if (!only || only === 'content') {
        this.siteEnabled = this.siteEnabled !== false;
        this.showCertificate = this.showCertificate !== false;
        this.showInquiry = this.showInquiry !== false;
        this.showForum = this.showForum !== false;
        this.banner1Active = true;
        this.coursesActive = true;
        fillText('coursesTitle', 'Nossos cursos');
        fillText('bannerTitle', 'Banner principal');
        fillText('bannerUrl', this.url || `https://${slug}.${this.domainSuffix}.com.br`);
        fillText('bannerDescription', 'Preview do banner da loja.');

        this.banner2Active = true;
        fillText('banner2Title', 'Conteúdo institucional');
        fillText('banner2Url', this.url || `https://${slug}.${this.domainSuffix}.com.br`);
        fillText('banner2Description', 'Preview do banner institucional.');

        this.testimonialsActive = true;
        fillText('testimonialsTitle', 'Depoimentos');
        const testimonyDefaults = [
          { name: 'Ana Preview', description: 'Excelente plataforma de estudos.' },
          { name: 'Bruno Preview', description: 'Conteúdo claro e organizado.' },
        ];
        this.testimonials = testimonyDefaults.map((defaults, index) => {
          const current = this.testimonials?.[index] || {};
          return {
            id: current.id || null,
            name: isBlank(current.name) ? defaults.name : current.name,
            description: isBlank(current.description) ? defaults.description : current.description,
            photo: current.photo || '',
            photoFinal: current.photoFinal || '',
            preview: current.preview || null,
          };
        });
        }

        if (!only || only === 'social') {
        this.socialActive = true;
        if (!Array.isArray(this.socialEnabled) || this.socialEnabled.every((item) => !item)) {
          this.socialEnabled = [true, true, false, false, false, false];
        }
        const socialDefaults = [
          'facebook.com/preview',
          'instagram.com/preview',
          '',
          '',
          '',
          '',
        ];
        this.socialLinks = socialDefaults.map((fallback, index) => (
          isBlank(this.socialLinks?.[index]) ? fallback : this.socialLinks[index]
        ));

        }

        const uploads = [];

        if (want('basic') && !hasAsset(this.logo, this.logoFinal, this.logoPreview)) {
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 320, height: 320, fileName: `logo-preview-${companyPart}.png`,
              background: brandColor, label: 'LOGO', sublabel: `Empresa ${companyPart}`,
            });
            await this.uploadCompanyAsset('logo', file);
          })());
        }

        if (want('basic') && !hasAsset(this.favicon, this.faviconFinal, this.faviconPreview)) {
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 256, height: 256, fileName: `favicon-preview-${companyPart}.png`,
              background: '#1f0770', label: 'F', sublabel: '',
            });
            await this.uploadCompanyAsset('favicon', file);
          })());
        }

        if ((!only || only === 'content') && !hasAsset(this.primaryBanner, this.primaryBannerFinal, this.primaryBannerPreview)) {
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 1280, height: 480, fileName: `banner-preview-${companyPart}.png`,
              background: brandColor, label: 'BANNER PRINCIPAL', sublabel: 'Preview Step 2', gradient: true,
            });
            await this.uploadBannerAsset(file);
          })());
        }

        if ((!only || only === 'content') && !hasAsset(this.banner2, this.banner2Final, this.banner2Preview)) {
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 1280, height: 480, fileName: `banner2-preview-${companyPart}.png`,
              background: '#7C5CFC', label: 'BANNER INSTITUCIONAL', sublabel: 'Conteúdo institucional', gradient: true,
            });
            await this.uploadBanner2Asset(file);
          })());
        }

        if (!only && this.isWeeduc && !hasAsset(this.portalBanner, this.portalBannerFinal, this.portalBannerPreview)) {
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 1280, height: 500, fileName: `portal-banner-${companyPart}.png`,
              background: '#1AC7D0', label: 'PORTAL', sublabel: 'Banner do portal', gradient: true,
            });
            await this.uploadPortalBannerAsset(file);
          })());
        }

        if (!only || only === 'content') for (let index = 0; index < this.testimonials.length; index += 1) {
          const item = this.testimonials[index];
          if (hasAsset(item.photo, item.photoFinal, item.preview)) continue;
          uploads.push((async () => {
            const file = await this.createPreviewImageFile({
              width: 400,
              height: 400,
              fileName: `testimony-${index + 1}-${companyPart}.png`,
              background: index === 0 ? '#250891' : '#1AC7D0',
              label: item.name?.slice(0, 1) || `D${index + 1}`,
              sublabel: `Depoimento ${index + 1}`,
            });
            await this.uploadTestimonyAsset(file, index);
          })());
        }

        if (uploads.length) {
          await Promise.all(uploads);
        }
      } catch (error) {
        console.error('Erro ao preencher dados do Step 2:', error);
        toast.error(error?.response?.data?.message || error?.message || 'Não foi possível gerar as imagens.');
      } finally {
        this.fillingPreview = false;
        this.hasReady = true;
      }
    },
    createPreviewImageFile({ width, height, fileName, background, label, sublabel = '', gradient = false }) {
      return new Promise((resolve, reject) => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject(new Error('Canvas não suportado neste navegador.'));
            return;
          }
          if (gradient) {
            const fill = ctx.createLinearGradient(0, 0, width, height);
            fill.addColorStop(0, background);
            fill.addColorStop(1, '#5b21b6');
            ctx.fillStyle = fill;
          } else {
            ctx.fillStyle = background;
          }
          ctx.fillRect(0, 0, width, height);
          ctx.fillStyle = '#ffffff';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.font = `700 ${Math.max(28, Math.round(height * 0.16))}px Inter, Arial, sans-serif`;
          ctx.fillText(label, width / 2, height / 2 - (sublabel ? height * 0.06 : 0));
          if (sublabel) {
            ctx.font = `500 ${Math.max(14, Math.round(height * 0.055))}px Inter, Arial, sans-serif`;
            ctx.fillStyle = 'rgba(255,255,255,0.88)';
            ctx.fillText(sublabel, width / 2, height / 2 + height * 0.12);
          }
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('Falha ao gerar imagem preview.'));
              return;
            }
            resolve(new File([blob], fileName, { type: 'image/png' }));
          }, 'image/png');
        } catch (error) {
          reject(error);
        }
      });
    },
    revokePreviewUrl(url) {
      if (url && String(url).startsWith('blob:')) URL.revokeObjectURL(url);
    },
    async uploadCompanyAsset(kind, file) {
      const previewKey = kind === 'logo' ? 'logoPreview' : 'faviconPreview';
      const tokenKey = kind === 'logo' ? 'logo' : 'favicon';
      const finalKey = kind === 'logo' ? 'logoFinal' : 'faviconFinal';
      this.revokePreviewUrl(this[previewKey]);
      this[previewKey] = URL.createObjectURL(file);
      this[finalKey] = null;
      const response = await apiAWS.getSignatureImageCompany(
        this.token, file.name, this.resolvedCompanyId, this.resolvedRepresentativeId,
      );
      await apiAWS.putFileAWS(response.url, file);
      this[tokenKey] = response.token;
    },
    async uploadBannerAsset(file) {
      this.revokePreviewUrl(this.primaryBannerPreview);
      this.primaryBannerPreview = URL.createObjectURL(file);
      this.primaryBannerFinal = null;
      const response = await apiAWS.getSignatureImage(this.token, file.name);
      await apiAWS.putFileAWS(response.url, file);
      this.primaryBanner = response.token;
    },
    async uploadPortalBannerAsset(file) {
      this.revokePreviewUrl(this.portalBannerPreview);
      this.portalBannerPreview = URL.createObjectURL(file);
      this.portalBannerFinal = null;
      const response = await apiAWS.getSignatureImage(this.token, file.name);
      await apiAWS.putFileAWS(response.url, file);
      this.portalBanner = response.token;
    },
    async uploadBanner2Asset(file) {
      this.revokePreviewUrl(this.banner2Preview);
      this.banner2Preview = URL.createObjectURL(file);
      this.banner2Final = null;
      const response = await apiAWS.getSignatureImage(this.token, file.name);
      await apiAWS.putFileAWS(response.url, file);
      this.banner2 = response.token;
    },
    async uploadTestimonyAsset(file, index) {
      if (!this.testimonials[index]) return;
      this.revokePreviewUrl(this.testimonials[index].preview);
      this.testimonials[index].preview = URL.createObjectURL(file);
      this.testimonials[index].photoFinal = '';
      const response = await apiAWS.getSignatureImage(this.token, file.name);
      await apiAWS.putFileAWS(response.url, file);
      this.testimonials[index].photo = response.token;
    },
    normalizeHex(value) {
      if (!value) return '#ffffff';
      let hex = String(value).trim();
      if (!hex.startsWith('#')) hex = `#${hex}`;
      if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
        hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
      }
      return /^#[0-9A-Fa-f]{6}$/.test(hex) ? hex : '#ffffff';
    },
    applyWebsite(website, companySource = null) {
      if (!website && !companySource) return;
      const source = website || {};
      this.title = source.title || source.nome || this.title;
      this.description = source.description ?? this.description;
      this.keywords = source.keywords ?? this.keywords;
      this.about = source.about ?? this.about;
      this.url = source.url ?? this.url;
      this.url1 = source.url1 ?? this.url1;
      this.url2 = source.url2 ?? this.url2;
      this.typeLayout = source.typeLayout ?? this.typeLayout;
      this.typeLayoutPortal = source.typeLayoutPortal ?? this.typeLayoutPortal;
      this.emailSite = source.email ?? this.emailSite;
      this.phoneSite = source.phone ?? this.phoneSite;
      this.color = this.normalizeHex(source.color || this.companyColor || this.color);
      this.logo = source.logo ?? this.logo;
      this.favicon = source.favicon ?? this.favicon;
      this.logoFinal = source.logoFinal ?? this.logoFinal;
      this.faviconFinal = source.faviconFinal ?? this.faviconFinal;
      this.urlTemporary = subdomainFromUrl(this.url, this.domainSuffix);
      this.siteEnabled = toFlag(source.status, true);
      this.showCertificate = toFlag(source.showCertificate, true);
      this.showInquiry = toFlag(source.showInquiry, true);
      this.showForum = toFlag(source.showForum, true);
      this.portalBanner = source.portalBannerPath ?? this.portalBanner;
      this.portalBannerFinal = source.portalBannerPathFinal ?? this.portalBannerFinal;
      this.css = source.css ?? this.css;
      this.javascript = source.javascript ?? this.javascript;
      this.typeImageCoverCourse = Number(source.typeImageCoverCourse || this.typeImageCoverCourse || 1);
      this.visibleTitleCourse = toFlag(source.visibleTitleCourse, true);
      this.integrations = {
        facebookPixelCode: source.facebookPixelCode ?? '',
        googleAdsCode: source.googleAdsCode ?? '',
        googleAnalyticsCode: source.googleAnalyticsCode ?? '',
        tagManagerCode: source.tagManagerCode ?? '',
        rdrefreshToken: source.rdrefreshToken ?? '',
        rdcode: source.rdcode ?? '',
        rdsecretClient: source.rdsecretClient ?? '',
        rdclienteId: source.rdclienteId ?? '',
      };

      const company = companySource || source.company || null;
      if (company) {
        this.companyName = company.name || company.tradeName || this.companyName;
        this.cartClosure = toFlag(company.cartStatus, false);
        this.showInstallmentValue = toFlag(company.intallmentCheckout, false);
      } else if (companySource === null && (source.cartStatus != null || source.intallmentCheckout != null)) {
        this.cartClosure = toFlag(source.cartStatus, false);
        this.showInstallmentValue = toFlag(source.intallmentCheckout, false);
        this.companyName = source.name || source.tradeName || this.companyName;
      }

      const contents = (
        Array.isArray(companySource?.contents) && companySource.contents.length
          ? companySource.contents
          : (Array.isArray(source.contents) ? source.contents : [])
      );
      this.applyContents(contents);

      const social = (
        Array.isArray(companySource?.socialMedia) && companySource.socialMedia.length
          ? companySource.socialMedia
          : (Array.isArray(source.socialMedia) && source.socialMedia.length
            ? source.socialMedia
            : (Array.isArray(companySource?.social) ? companySource.social : []))
      );
      this.applySocial(social);
      if (this.isWeflix) {
        this.socialActive = true;
        if (this.typeLayout == null || this.typeLayout === '') {
          this.typeLayout = 0;
        }
      }

      const testimonials = (
        Array.isArray(companySource?.testimonials) && companySource.testimonials.length
          ? companySource.testimonials
          : (Array.isArray(source.testimonials) && source.testimonials.length
            ? source.testimonials
            : (Array.isArray(companySource?.testimonies) ? companySource.testimonies : []))
      );
      this.applyTestimonials(testimonials);
    },
    applyContents(contents) {
      if (!Array.isArray(contents) || !contents.length) return;
      contents.forEach((item) => {
        const type = Number(item?.type);
        if (!type) return;
        this.contentIds = { ...this.contentIds, [type]: item.id || this.contentIds[type] };
        if (type === 1) {
          this.banner1Active = toFlag(item.status, true);
          this.primaryBanner = item.pathImage || this.primaryBanner;
          this.primaryBannerFinal = item.pathImageFinal || this.primaryBannerFinal;
          this.bannerTitle = item.title || this.bannerTitle;
          this.bannerUrl = item.url || this.bannerUrl;
          this.bannerDescription = item.description || this.bannerDescription;
        } else if (type === 2) {
          this.coursesActive = toFlag(item.status, true);
          this.coursesTitle = item.title || this.coursesTitle;
        } else if (type === 3) {
          this.banner2Active = toFlag(item.status, false);
          this.banner2 = item.pathImage || this.banner2;
          this.banner2Final = item.pathImageFinal || this.banner2Final;
          this.banner2Title = item.title || this.banner2Title;
          this.banner2Url = item.url || this.banner2Url;
          this.banner2Description = item.description || this.banner2Description;
        } else if (type === 4) {
          this.testimonialsActive = toFlag(item.status, false);
          this.testimonialsTitle = item.title || this.testimonialsTitle;
        }
      });
    },
    applySocial(list) {
      if (!Array.isArray(list) || !list.length) return;
      this.socialActive = true;
      const enabled = Array.isArray(this.socialEnabled) ? [...this.socialEnabled] : [false, false, false, false, false, false];
      const links = Array.isArray(this.socialLinks) ? [...this.socialLinks] : ['', '', '', '', '', ''];
      const ids = Array.isArray(this.socialIds) ? [...this.socialIds] : [null, null, null, null, null, null];
      list.forEach((item) => {
        const type = Number(item.type);
        if (Number.isNaN(type) || type < 0 || type > 5) return;
        ids[type] = item.id || null;
        enabled[type] = toFlag(item.status, false);
        links[type] = item.url || '';
      });
      this.socialIds = ids;
      this.socialEnabled = enabled;
      this.socialLinks = links;
    },
    applyTestimonials(list) {
      if (!Array.isArray(list) || !list.length) return;
      this.testimonialsActive = true;
      // API pode acumular duplicatas; usa os 2 mais recentes (maior id).
      const selected = [...list]
        .sort((a, b) => Number(a?.id || 0) - Number(b?.id || 0))
        .slice(-2);
      while (selected.length < 2) {
        selected.push({ id: null, name: '', description: '', photo: '', photoFinal: '' });
      }
      this.testimonials = selected.map((item) => ({
        id: item.id || null,
        name: item.name || '',
        description: item.description || '',
        photo: item.photo || '',
        photoFinal: item.photoFinal || '',
        preview: null,
      }));
    },
    async bootstrap() {
      this.formReady = false;
      this.color = this.normalizeHex(this.companyColor);
      if (this.initialWebsite || this.initialCompany) {
        this.applyWebsite(this.initialWebsite, this.initialCompany);
        this.formReady = true;
        this.$emit('ready');
        return;
      }
      const id = this.resolvedCompanyId;
      if (!id) {
        this.formReady = true;
        this.$emit('ready');
        return;
      }
      try {
        const response = await superAdmin.createCompanyById(this.token, id);
        const website = extractWebsite(response);
        if (website) this.applyWebsite(website, response);
        else if (response) {
          this.applyWebsite(null, response);
          if (response.color) this.color = this.normalizeHex(response.color);
        }
      } catch (error) {
        console.error('Erro ao carregar website da empresa:', error);
      } finally {
        this.formReady = true;
        this.$emit('ready');
      }
    },
    async putFileAws(url, file) {
      try {
        await apiAWS.putFileAWS(url, file);
      } catch (error) {
        console.error('Erro ao enviar arquivo para AWS');
      }
    },
    async updateFilePathLogo(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.logoPreview = URL.createObjectURL(file);
      try {
        const response = await apiAWS.getSignatureImageCompany(
          this.token, file.name, this.resolvedCompanyId, this.resolvedRepresentativeId,
        );
        this.putFileAws(response.url, file);
        this.logo = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    async updateFilePathFavicon(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.faviconPreview = URL.createObjectURL(file);
      try {
        const response = await apiAWS.getSignatureImageCompany(
          this.token, file.name, this.resolvedCompanyId, this.resolvedRepresentativeId,
        );
        this.putFileAws(response.url, file);
        this.favicon = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    async updateFilePathBanner(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.primaryBannerPreview = URL.createObjectURL(file);
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name);
        this.putFileAws(response.url, file);
        this.primaryBanner = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    async updateFilePathBanner2(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.revokePreviewUrl?.(this.banner2Preview);
      this.banner2Preview = URL.createObjectURL(file);
      this.banner2Final = null;
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name);
        this.putFileAws(response.url, file);
        this.banner2 = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    async updateFilePathTestimony(event, index) {
      const file = event.target.files[0];
      if (!file || !this.testimonials[index]) return;
      this.revokePreviewUrl?.(this.testimonials[index].preview);
      this.testimonials[index].preview = URL.createObjectURL(file);
      this.testimonials[index].photoFinal = '';
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name);
        this.putFileAws(response.url, file);
        this.testimonials[index].photo = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    async updateFilePathPortalBanner(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.portalBannerPreview = URL.createObjectURL(file);
      try {
        const response = await apiAWS.getSignatureImage(this.token, file.name);
        this.putFileAws(response.url, file);
        this.portalBanner = response.token;
      } catch (error) {
        console.error('Erro na geração do TOKEN AWS');
      }
    },
    buildContentsPayload() {
      if (this.isWeflix) return [];
      const items = [
        {
          type: 1,
          title: this.bannerTitle || '',
          description: this.bannerDescription || '',
          pathImage: this.primaryBanner,
          url: this.bannerUrl || '',
          order: 1,
          status: flagNumber(this.banner1Active),
          statusEnum: this.banner1Active ? 'Ativo' : 'Inativo',
          typeEnum: '',
        },
        {
          type: 2,
          title: this.coursesTitle || '',
          description: '',
          pathImage: '',
          url: '',
          order: 2,
          status: flagNumber(this.coursesActive),
          statusEnum: this.coursesActive ? 'Ativo' : 'Inativo',
          typeEnum: '',
        },
        {
          type: 3,
          title: this.banner2Title || '',
          description: this.banner2Description || '',
          pathImage: this.banner2,
          url: this.banner2Url || '',
          order: 3,
          status: flagNumber(this.banner2Active),
          statusEnum: this.banner2Active ? 'Ativo' : 'Inativo',
          typeEnum: '',
        },
        {
          type: 4,
          title: this.testimonialsTitle || '',
          description: '',
          pathImage: '',
          url: '',
          order: 4,
          status: flagNumber(this.testimonialsActive),
          statusEnum: this.testimonialsActive ? 'Ativo' : 'Inativo',
          typeEnum: '',
        },
      ];
      return items.map((item) => {
        const id = this.contentIds[item.type];
        return id ? { ...item, id } : item;
      });
    },
    buildSocialPayload() {
      if (this.isWeflix) {
        this.socialActive = true;
      }
      if (!this.socialActive) return [];
      return this.socialNames
        .map((name, index) => {
          const url = (this.socialLinks[index] || '').trim();
          if (!url && !this.socialIds[index]) return null;
          const item = {
            name,
            type: index,
            url: url || null,
            status: flagNumber(this.socialEnabled[index] && !!url),
          };
          if (this.socialIds[index]) item.id = this.socialIds[index];
          return item;
        })
        .filter(Boolean);
    },
    buildTestimonialsPayload() {
      if (this.isWeflix || !this.testimonialsActive) return [];
      return this.testimonials
        .filter((item) => item.name || item.description || item.photo || item.id)
        .map((item) => {
          const payload = {
            name: item.name || '',
            description: item.description || '',
            photo: item.photo || '',
          };
          if (item.id) payload.id = item.id;
          return payload;
        });
    },
    resolveWebsiteName() {
      const candidates = [this.title, this.companyName, this.urlTemporary];
      for (const value of candidates) {
        const text = value != null ? String(value).trim() : '';
        if (text) return text;
      }
      return '';
    },
    async saveLayout() {
      this.hasReady = false;

      if (this.urlTemporary) {
        this.createFullDomain();
      }

      const websiteName = this.resolveWebsiteName();
      if (!websiteName) {
        this.hasReady = true;
        toast.warning('Preencha o título do site ou o nome do domínio antes de salvar.');
        this.openSection('basic');
        return;
      }

      if (!this.title) {
        this.title = websiteName;
      }

      const payload = {
        idCompany: this.resolvedCompanyId,
        website: {
          nome: websiteName,
          url: this.url || null,
          url1: this.url1 || null,
          url2: this.url2 || null,
          title: this.title || websiteName,
          description: this.description || null,
          keywords: this.keywords || null,
          logo: this.logo || null,
          about: this.about || null,
          favicon: this.favicon || null,
          status: flagNumber(this.siteEnabled),
          typeLayout: this.typeLayout,
          typeLayoutPortal: this.typeLayoutPortal,
          email: this.emailSite || null,
          phone: this.phoneSite || null,
          color: this.color || '#250891',
          showCertificate: flagNumber(this.showCertificate),
          showInquiry: flagNumber(this.showInquiry),
          showForum: flagNumber(this.showForum),
          portalBannerPath: this.portalBanner || null,
          css: this.css || '',
          javascript: this.javascript || '',
          typeImageCoverCourse: Number(this.typeImageCoverCourse) || 1,
          visibleTitleCourse: flagNumber(this.visibleTitleCourse),
          ...this.integrations,
        },
        contents: this.buildContentsPayload(),
        socialMedia: this.buildSocialPayload(),
        testimonials: this.buildTestimonialsPayload(),
      };

      if (this.isWeflix) {
        payload.company = {
          cartStatus: flagNumber(this.cartClosure),
          intallmentCheckout: flagNumber(this.showInstallmentValue),
          name: this.companyName || this.title || undefined,
        };
      }

      try {
        const saved = await superAdmin.editLayoutCompany(this.token, payload);
        if (this.isWeflix && this.resolvedCompanyId) {
          try {
            await superAdmin.updateCompany(this.token, this.resolvedCompanyId, {
              cartStatus: flagNumber(this.cartClosure),
              intallmentCheckout: flagNumber(this.showInstallmentValue),
              name: this.companyName || this.title,
            });
          } catch (companyError) {
            console.warn('Checkout Weflix: updateCompany falhou (pode estar no site upsert):', companyError);
          }
        }
        this.hasReady = true;
        if (saved?.videoteca && saved.videoteca.ok === false) {
          toast.warning(saved.videoteca.message || 'Site salvo, mas a pasta da Videoteca não foi criada.');
        } else if (this.notifyOnSave) {
          toast.success('Layout da empresa salvo com sucesso.');
        }
        this.$emit('saved');
        if (this.redirectOnSave) {
          this.$router.push('/admin/empresas/');
        }
      } catch (error) {
        console.error(error);
        this.hasReady = true;
        toast.error(
          error?.response?.data?.message
          || error?.response?.data?.error
          || error?.message
          || 'Erro ao salvar o layout da empresa.',
        );
      }
    },
    createFullDomain() {
      this.hasValidDomain = null;
      this.urlTemporary = (this.urlTemporary || '')
        .replace(/[^\w\s]/gi, '')
        .replace(/\s+/g, '')
        .toLowerCase()
        .slice(0, 30);
      this.url = `https://${this.urlTemporary}.${this.domainSuffix}.com.br`;
    },
    async validateDomain() {
      const slug = String(this.urlTemporary || '')
        .replace(/[^\w\s]/gi, '')
        .replace(/\s+/g, '')
        .trim();
      if (!slug) {
        this.hasValidDomain = null;
        this.showDomainRequiredModal = true;
        return;
      }
      try {
        this.hasValidDomain = await apiSiteDomain.postVerifyDomaintData(this.token, { url: this.url });
      } catch (error) {
        console.error(error);
        this.hasValidDomain = false;
      }
    },
    copyLink() {
      if (!this.url) return;
      navigator.clipboard.writeText(this.url);
    },
    setColor(color) {
      this.color = color;
    },
  },
  created() {
    this.applyStepFromQuery();
    this.bootstrap();
    this.emitStepChange();
  },
};
</script>

<style scoped>
.company-step2-form {
  width: 100%;
  text-align: left;
}

.domain-required-modal {
  border-radius: 12px;
  text-align: left;
}

.domain-required-modal__title {
  color: #191c24;
  font-size: 1.05rem;
  font-weight: 700;
  padding: 1.25rem 1.25rem 0.35rem;
}

.domain-required-modal__text {
  color: #697386;
  font-size: 0.95rem;
  line-height: 1.45;
  padding: 0.35rem 1.25rem 0.5rem;
}

.domain-required-modal__actions {
  justify-content: flex-end;
  padding: 0.5rem 1.25rem 1.15rem;
}

.domain-required-modal__btn {
  background-color: #250891;
  color: #fff;
  border: none;
  border-radius: 8px;
  min-width: 120px;
  padding: 10px 22px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
}

.domain-required-modal__btn:hover {
  background-color: #1f0770;
}

.step2-field-spaced.col-form-inner {
  margin-top: 1.25rem;
  margin-bottom: 1.75rem;
}

.step2-context {
  margin: 0 0 1rem;
  color: #697386;
  font-size: 0.8125rem;
  line-height: 1.45;
}

.step2-accordions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.step2-accordion {
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.step2-accordion__toggle {
  appearance: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.1rem;
  border: 0;
  background: #f8f9fc;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background-color 150ms ease;
}

.step2-accordion.is-open .step2-accordion__toggle {
  background: #f3f0ff;
  border-bottom: 1px solid #e8eaf0;
}

.step2-accordion__toggle:hover {
  background: #f0edfa;
}

.step2-accordion__toggle:focus-visible {
  outline: 2px solid #250891;
  outline-offset: -2px;
}

.step2-accordion__copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.step2-accordion__copy strong {
  color: #191c24;
  font-size: 0.9375rem;
  font-weight: 700;
}

.step2-accordion__copy small {
  color: #697386;
  font-size: 0.78rem;
  line-height: 1.4;
}

.step2-accordion__chevron {
  color: #250891;
  flex-shrink: 0;
  width: 0.9rem;
  height: 0.9rem;
}

.step2-accordion__body {
  padding: 1.1rem 1.1rem 1.25rem;
}

.step2-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e8eaf0;
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 2;
}

.step2-footer__spacer {
  flex: 1;
}

.step2-toggle-list {
  display: flex;
  flex-direction: column;
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 0.25rem;
}

.step2-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.1rem;
  background: #fff;
  text-align: left;
}

.step2-toggle-row + .step2-toggle-row {
  border-top: 1px solid #eef0f4;
}

.step2-toggle-row__copy {
  min-width: 0;
  flex: 1 1 auto;
  text-align: left;
}

.step2-toggle-row__copy strong {
  display: block;
  color: #191c24;
  font-size: 0.875rem;
  font-weight: 600;
  text-align: left;
}

.step2-toggle-row__copy p {
  margin: 0.2rem 0 0;
  color: #697386;
  font-size: 0.78rem;
  line-height: 1.4;
  max-width: 42rem;
  text-align: left;
}

.step2-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  user-select: none;
  text-align: left;
}

.step2-switch input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.step2-switch__track {
  position: relative;
  width: 2.5rem;
  height: 1.4rem;
  border-radius: 999px;
  background: #d5d9e2;
  transition: background-color 160ms ease;
  flex-shrink: 0;
}

.step2-switch__track::after {
  content: '';
  position: absolute;
  top: 0.15rem;
  left: 0.15rem;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 160ms ease;
}

.step2-switch input:checked + .step2-switch__track {
  background: #250891;
}

.step2-switch input:checked + .step2-switch__track::after {
  transform: translateX(1.1rem);
}

.step2-switch input:focus-visible + .step2-switch__track {
  outline: 2px solid #250891;
  outline-offset: 2px;
}

.step2-switch__text {
  min-width: 2.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #697386;
}

.step2-switch input:checked ~ .step2-switch__text {
  color: #250891;
}

.step2-content-blocks .step2-block-fields {
  padding: 0 1.1rem 1rem;
  border-top: 0;
  background: #fafbff;
}

.step2-content-blocks .step2-toggle-row + .step2-block-fields + .step2-toggle-row,
.step2-content-blocks .step2-block-fields + .step2-toggle-row {
  border-top: 1px solid #eef0f4;
}

.step2-testimonial-card {
  border: 1px solid #e8eaf0;
  border-radius: 12px;
  padding: 0.85rem;
  background: #fff;
  text-align: left;
}

.step2-social-row {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.75rem;
  border: 1px solid #e8eaf0;
  border-radius: 10px;
  background: #fff;
  text-align: left;
}

.step2-social-row__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.step2-social-row__head strong {
  font-size: 0.8125rem;
  color: #191c24;
}

.step2-code {
  min-height: 160px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8rem;
}

.warn {
  color: #b45309;
}

.ok {
  color: #15803d;
}

.error {
  color: #b91c1c;
}

.domain-status-msg {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.35rem;
  font-weight: 600;
}

.domain-status-msg svg,
.domain-status-msg .svg-inline--fa {
  width: 0.85rem;
  height: 0.85rem;
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .step2-toggle-row {
    align-items: flex-start;
  }

  .step2-accordion__toggle {
    align-items: flex-start;
  }
}
</style>
